module.exports = __webpack_public_path__ + "img/icici.36c763f5.png";